import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="testimonials-heading" data-id="element-148" data-mp="3fycrjpy4ubcd">
      <div className="mx-auto max-w-6xl px-5" data-id="element-149" data-mp="3azjcvu740eam">
        <div id="testimonials-heading" data-id="element-150" data-mp="3ayqdjeahcr2i">
          <SectionHeading eyebrow="Loved by moms and kids" title="See what moms are saying after getting My Enchanted Paper World" data-id="element-151" data-mp="36z96whjbhnvr" />
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-152" data-mp="2x0jmah01dpbt">
          {testimonials.map((testimonial, index) => <motion.figure key={testimonial.author} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.45,
          delay: index * 0.1
        }} className="flex flex-col rounded-3xl border-2 border-white bg-white p-6 shadow-card" data-id="element-153" data-mp="2s2i4s0i9dy2g" data-mpi={index}>
              <div className="flex gap-0.5 text-sun-500" aria-label="5 out of 5 stars" data-id="element-154" data-mp="m5kmoqccuxdh">
                {Array.from({
              length: 5
            }).map((_, starIndex) => <StarIcon key={starIndex} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-155" data-mp="79v8hedevojb" data-mpi={starIndex} />)}
              </div>
              <blockquote className="mt-3 flex-1 text-sm italic leading-relaxed text-ink/80" data-id="element-156" data-mp="zysf2k89fww8">
                &ldquo;{testimonial.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-4 font-display font-bold text-blush-500" data-id="element-157" data-mp="q6ctze1o2s74">
                — {testimonial.author}
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}